import config from '../..//services/config';
import BaseDrawingObject from "./baseDrawingObject";

class Circle extends BaseDrawingObject {
    constructor(centreX, centreY, radius, circleType, fill, blockName, layerNumber, objNumSeqNum, closedIndicator) {
        super();
        this.centre = { x: centreX, y: centreY };
    
        this.radius = radius;
        this.fillColour = config.DRAWING_COLOURS.WHITE;
        this.fill = fill;
        this.blockName = blockName;
        this.layerNumber = layerNumber;
        this.circleType = circleType;
        this.objNumSeqNum = objNumSeqNum;
        this.closedIndicator = closedIndicator;
        this.type = 'circle';
        this.dashEnabled = true;
        this.dash = 1;
        if (objNumSeqNum !== undefined && objNumSeqNum.indexOf('_') > -1) {
            this.objectNumber = parseInt(objNumSeqNum.substring(0, objNumSeqNum.lastIndexOf("_")));
            this.sequenceNumber = parseInt(objNumSeqNum.substring(objNumSeqNum.lastIndexOf("_") + 1));
        } 
        this.axlePosition = -1;
        this.groundLineY = -1;


        if (blockName !== undefined && blockName.indexOf('DASHED') > -1) {
            this.dashEnabled = true;
        } else {
            this.dashEnabled = false;
        }
        this.setDashed = function (dashedBool) {
            this.dashEnabled = dashedBool;
        }
        this.setDashLength = function (dashLength) {
            this.dash = dashLength;
        }

        this.setShowAsWarning = function (showAsWarning) {
            this.showAsWarning = showAsWarning;
        }

        // this.drawingGroupName = config.CHASSIS_OBJECT_TYPES.VEHICLE;
        // function setDrawingGroupName(group) {
        //     this.drawingGroupName = group;
        //     return this;
        // }
        // this.setDrawingGroupName = setDrawingGroupName;
        //this.drawAxleLetter
        this.setColour = function (colour) {
            this.colour = colour;
        }

        this.drawGroundline = false;
        this.setDrawGroundline = function (newValue) {
            this.drawGroundline = newValue;
        }

        this.bypassHitAreaSort = false;
        this.setBypassHitAreaSort = function (newValue) {
            this.bypassHitAreaSort = newValue;
        }

        this.setDrawingOrder = function (newValue) {
            this.drawingOrder = newValue;
        }

        this.setPulse = function (newValue) {
            this.pulse = newValue;
        }

        this.setPulseColour = function (colour) {
            this.pulseColour = colour;
        }

        // this.setBringToFront = function (newValue) {
        //     this.bringToFront = newValue;
        // }

        // this.setLineWidth = function (newValue) {
        //     this.lineWidth = newValue;
        // }
    }
}


//var Circle = function (meta) {

//    var self = this;

//    self.centre = { x: meta.centreX, y: meta.centreY };
//    self.radius = meta.radius;

//    if (meta.dataType === "FULL") {
//        self.fill = meta.fill;
//        self.blockName = meta.blockName;
//        self.layerNumber = meta.layerNumber;
//        self.circleType = meta.circleType;
//        self.objNumSeqNum = meta.objNumSeqNum;
//        self.closedIndicator = meta.closedIndicator;
        
//    } else {
//        self.circleType = meta.circleType;
//    }

//    self.type = 'circle';
//};

export default Circle;

    